export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-b4e890319bfbd44a730c.worker.js");
}
